import React from "react";
import { Modal, Spin, Typography } from "antd";

// نظام الألوان
const colors = {
    primary: '#00b362',
    primaryLight: '#63ff8a',
    primaryDark: '#008b20',
    primaryGradient: 'linear-gradient(135deg, #00b362 0%, #00d4aa 100%)',
    white: '#ffffff',
    gray: '#979595',
};

// أحجام الخطوط
const textSizes = {
    16: '1.6rem',
    20: '2.1rem',
    24: '2.5rem'
};

export default function CheckoutProgressModal({ open }) {
    return (
        <Modal
            open={open}
            footer={null}
            closable={false}
            centered
            width={420}
            styles={{
                mask: { backgroundColor: "rgba(0,0,0,0.55)" },
                content: {
                    padding: 0,
                    borderRadius: 20,
                    overflow: "hidden",
                    background: colors.white,
                }
            }}
        >
            <div
                style={{
                    padding: "40px 30px",
                    textAlign: "center",
                    background: colors.primaryGradient,
                    color: colors.white,
                }}
            >
                <Spin size="large" />
                <Typography.Title
                    level={3}
                    style={{
                        marginTop: 20,
                        marginBottom: 0,
                        fontSize: textSizes[24],
                        color: colors.white,
                    }}
                >
                    جاري تنفيذ طلبك
                </Typography.Title>
                <Typography.Text
                    style={{
                        display: "block",
                        marginTop: 10,
                        fontSize: textSizes[16],
                        color: colors.white,
                        opacity: 0.9,
                    }}
                >
                    الرجاء الانتظار قليلاً…
                </Typography.Text>
            </div>

            <div
                style={{
                    padding: "22px 26px",
                    textAlign: "center",
                    background: colors.white,
                }}
            >
                <Typography.Text
                    style={{
                        fontSize: textSizes[16],
                        color: colors.gray,
                    }}
                >
                    يتم الآن معالجة عملية الدفع والتحقق من المعلومات
                </Typography.Text>
            </div>
        </Modal>
    );
}